import { Chip, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import clsx from "clsx";
import OptimizedTooltip from "../../common/OptimizedTooltip";
import MessageIcon from "@material-ui/icons/Message";
import PinIcon from "@material-ui/icons/PinDrop";
import { remCalc, secondsToTime } from "../../../utils/helpers";
import { connect } from "react-redux";
import { setPinpointDriver } from "../../../store/actions/map";

const useStyles = makeStyles(theme => ({
  chipsWrapper: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(3, 4.5, 0)
  },
  chip: {
    fontSize: remCalc(14),
    height: remCalc(28),
    fontWeight: 500,
    marginRight: theme.spacing(1),
    backgroundColor: "#DDD",
    color: theme.palette.text.primary
  },
  chipDelivered: {
    color: "#fff",
    backgroundColor: "#07A35A"
  },
  chipOnTime: {
    color: "#07A35A",
    backgroundColor: "#D7F0E5"
  },
  chipSkipped: {
    color: "#fff",
    backgroundColor: "#FF0366"
  },
  chipLate: {
    color: "#F50057",
    backgroundColor: "#FDD6E4"
  },
  chipEarly: {
    color: "#F1AE00",
    backgroundColor: "rgba(254, 183, 0, 0.24)"
  },
  chipIcon: {
    width: remCalc(28),
    cursor: "pointer",

    "& svg": {
      fontSize: remCalc(16),
      color: theme.variables.rootColor
    },

    "& *": {
      pointerEvents: "none"
    }
  },
  tooltipBody: {
    maxWidth: 208,
    padding: theme.spacing(1.5, 1),
    "& p": {
      fontSize: ".8125rem !important",
      lineHeight: "15px"
    }
  },
  tooltipTitle: {
    marginBottom: theme.spacing(0.5)
  },
  noteBlock: {
    "& > div:first-of-type": {
      marginBottom: theme.spacing(2)
    }
  },
  locationIcon: {
    overflow: "initial",
    display: "flex",
    alignItems: "center"
  }
}));

function StatusIndicators({ task, pinpointDriver, setPinpointDriver }) {
  const classes = useStyles();

  const timeWindowLatest =
    task.time_windows && task.time_windows.length
      ? task.time_windows[0].latest
      : 86400;

  const timeWindowEarliest =
    task.time_windows && task.time_windows.length
      ? task.time_windows[0].earliest
      : 0;

  const handlePinpointClick = e => {
    e.stopPropagation();

    setPinpointDriver(
      pinpointDriver
        ? null
        : {
            id: task.id,
            finishAddress: task.finish_address
          }
    );
  };
  return (
    <div className={classes.chipsWrapper}>
      {/* Status */}
      {task.status === "finished" ? (
        <Chip
          className={clsx(classes.chip, classes.chipDelivered)}
          label={task.type === "pickup" ? "Picked up" : "Delivered"}
        />
      ) : (
        <Chip
          className={clsx(classes.chip, classes.chipSkipped)}
          label="Skipped"
        />
      )}
      {/* Early / On time / Late */}
      {task.status === "finished" && (
        <Chip
          className={clsx(
            classes.chip,
            timeWindowEarliest > task.finish_time
              ? classes.chipEarly
              : timeWindowLatest > task.finish_time
              ? classes.chipOnTime
              : classes.chipLate
          )}
          label={
            timeWindowEarliest > task.finish_time
              ? "Early"
              : timeWindowLatest > task.finish_time
              ? "On-time"
              : "Late"
          }
        />
      )}
      {/* Time */}
      <Chip className={classes.chip} label={secondsToTime(task.finish_time)} />
      {/* Driver pinpoint */}
      {task.status === "finished" &&
        task.finish_address.lat &&
        task.finish_address.lng && (
          <OptimizedTooltip
            placement="bottom"
            title={"Show driver's finish location"}
          >
            <Chip
              className={clsx(
                classes.chip,
                classes.chipIcon,
                "pinpoint-anchor"
              )}
              classes={{ label: classes.locationIcon }}
              label={<PinIcon />}
              onClick={handlePinpointClick}
            />
          </OptimizedTooltip>
        )}
      {/* Note */}
      {(task.completion_note || task.recipient_note) && (
        <OptimizedTooltip
          PopperProps={{
            className: "tooltip-info-window"
          }}
          // className={classes.tooltip}
          placement="bottom-start"
          title={
            <div
              className={clsx(classes.tooltipBody, {
                [classes.noteBlock]: task.recipient_note && task.completion_note
              })}
            >
              {task.recipient_note && (
                <div>
                  <Typography className={classes.tooltipTitle}>
                    <b>Note for recipient</b>
                  </Typography>
                  <Typography>{task.recipient_note}</Typography>
                </div>
              )}
              {task.completion_note && (
                <div>
                  <Typography className={classes.tooltipTitle}>
                    <b>Note for internal use</b>
                  </Typography>
                  <Typography>{task.completion_note}</Typography>
                </div>
              )}
            </div>
          }
        >
          <Chip
            className={clsx(classes.chip, classes.chipIcon)}
            classes={{ label: classes.locationIcon }}
            label={<MessageIcon />}
          />
        </OptimizedTooltip>
      )}
    </div>
  );
}

const mapStateToProps = state => ({
  pinpointDriver: state.map.pinpointDriver
});

export default connect(mapStateToProps, { setPinpointDriver })(
  StatusIndicators
);
